import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { XCircle } from "lucide-react";

const PaymentFailed = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <Card className="max-w-md w-full text-center">
        <CardHeader className="pb-4">
          <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center">
            <XCircle className="w-8 h-8 text-destructive" />
          </div>
          <CardTitle className="text-2xl">
            {t("subscription.failed.title")}
          </CardTitle>
          <CardDescription className="text-lg">
            {t("subscription.failed.subtitle")}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground">
            {t("subscription.failed.description")}
          </p>
          <div className="flex flex-col gap-2">
            <Button onClick={() => navigate("/#pricing")} size="lg">
              {t("subscription.failed.tryAgain")}
            </Button>
            <Button 
              variant="outline" 
              onClick={() => window.open("mailto:support@catedward.info", "_blank")}
            >
              {t("subscription.failed.contactSupport")}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentFailed;
